import {
  AfterViewInit,
  Component,
  EventEmitter,
  OnInit,
  inject
} from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
  MatDialogContent
} from "@angular/material/dialog";
import { ResourceAvailabilityStore } from "@app/services/store/resource-availability-store";
import { ResourceModel } from "@app/models/rest/resource";
import {
  Attribution,
  defaults as defaultControls,
  FullScreen,
  ScaleLine
} from "ol/control";
import {
  defaults as defaultInteractions,
  DragRotateAndZoom
} from "ol/interaction";
import Map from "ol/Map";
import View from "ol/View";
import Feature from "ol/Feature";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import Point from "ol/geom/Point";
import { Fill, Icon, Stroke, Style, Text } from "ol/style";
import { fromLonLat } from "ol/proj";
import GeoJSON from "ol/format/GeoJSON";
import { RouteService } from "@app/services/http/route.service";
import { ResourceAvailability } from "@app/models/rest/resource-availability";
import { Ticket, Ticket_DetailProjection } from "@app/models/rest/ticket";
import { RouteMessage } from "@app/models/dto/route-message";
import { TicketStreamingStore } from "@app/services/streaming/ticket-streaming-store";
import { createEmpty, extend } from "ol/extent";
import { TicketActionDialogComponent } from "@app/view/planning/ticket-action-dialog/ticket-action-dialog.component";
import XYZ from "ol/source/XYZ";
import {
  ClientConfigService,
  TicketColoursConfig
} from "@app/core/config/client-config.service";
import { CdkScrollable } from "@angular/cdk/scrolling";
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
  MatExpansionPanelDescription
} from "@angular/material/expansion";
import { NgClass } from "@angular/common";
import { MatList, MatListItem } from "@angular/material/list";
import { MomentModule } from "ngx-moment";
import { DialogHeaderComponent } from "../../shared/dialog-header/dialog-header.component";

class ResourceScheduleDetail {
  public ticket: Ticket_DetailProjection;
  public route: RouteMessage;
  public background: string;
  public foreground: string;
}

@Component({
  selector: "app-resource-detail",
  templateUrl: "./resource-detail.component.html",
  styleUrls: ["./resource-detail.component.scss"],
  imports: [
    CdkScrollable,
    MatDialogContent,
    MatAccordion,
    MatExpansionPanel,
    NgClass,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatExpansionPanelDescription,
    MatList,
    MatListItem,
    MomentModule,
    DialogHeaderComponent
  ]
})
export class ResourceDetailComponent implements OnInit, AfterViewInit {
  dialogRef = inject<MatDialogRef<ResourceDetailComponent>>(MatDialogRef);
  ticketStore = inject(TicketStreamingStore);
  resourceAvailabilityStore = inject(ResourceAvailabilityStore);
  dialog = inject(MatDialog);
  routeService = inject(RouteService);
  private clientConfigService = inject(ClientConfigService);
  data = inject<{
    resource: ResourceModel;
    dateFrom: Date;
    dateTo: Date;
  }>(MAT_DIALOG_DATA);

  loading = true;
  pending = false;
  resource: ResourceModel;
  resourceScheduleDetails: ResourceScheduleDetail[] = [];
  public onHoverChanged = new EventEmitter<Ticket[]>();
  public selectedTicket: Ticket;
  private map: Map;
  private selected: any;
  private routeLayer: VectorLayer<any>;
  private routeSource: VectorSource<any>;
  private jobLayer: VectorLayer<any>;
  private jobSource: VectorSource<any>;
  private highlightLayer: VectorLayer<any>;
  private highlightSource: VectorSource<any>;
  private styles = {
    route: [
      new Style({
        stroke: new Stroke({
          color: "rgba(0,42,255,0.5)",
          width: 6
        })
      }),
      new Style({
        stroke: new Stroke({
          color: "rgba(70,134,255,0.5)",
          width: 4
        })
      })
    ],
    job: new Style({
      image: new Icon({
        anchor: [0.5, 1],
        color: "rgb(78,14,119)",
        src: "assets/markers/job1.svg"
      })
    }),
    home: new Style({
      image: new Icon({
        anchor: [0.5, 1],
        color: "rgb(78,14,119)",
        src: "assets/markers/job1.svg"
      })
    })
  };

  private highlightStyles = {
    route: [
      new Style({
        stroke: new Stroke({
          color: "rgba(0,42,255,1)",
          width: 8
        })
      }),
      new Style({
        stroke: new Stroke({
          color: "rgba(70,134,255,1)",
          width: 6
        })
      })
    ],
    job: new Style({
      image: new Icon({
        anchor: [0.5, 1],
        color: "rgb(78,14,119)",
        src: "assets/markers/job1.svg"
      })
    }),
    home: new Style({
      image: new Icon({
        anchor: [0.5, 1],
        color: "rgb(78,14,119)",
        src: "assets/markers/job1.svg"
      })
    })
  };
  private loadDataPromise: Promise<any>;
  private mainView: View;
  private _colors: TicketColoursConfig;

  constructor() {
    const data = this.data;

    this.resource = data.resource;
    this._colors = this.clientConfigService.config.ticketColours;
  }

  ngOnInit() {
    this.ticketStore.updateStream?.subscribe((ticket: Ticket) => {
      console.log("got ticket update");
      if (!ticket) {
        return;
      }
      this.ticketStore
        .loadSingleProjection<Ticket_DetailProjection>(
          Ticket_DetailProjection,
          ticket.id,
          "detail"
        )
        .then((value) => {
          if (value.resourceAvailability) {
            console.log("resource id", value.resourceAvailability.resource.id);
            console.log("active id", this.resource.id);
          }
          if (
            value.resourceAvailability &&
            value.resourceAvailability.resource.id === this.resource.id
          ) {
            console.log("update required");
            this.resourceScheduleDetails = [];
            if (this.loading) {
              this.pending = true;
            } else {
              this.loading = true;
              this.loadDataPromise = this.initData();

              // this.initMap();
            }
          }
        });
    });
  }

  ngAfterViewInit(): void {
    this.loadDataPromise = this.initData();
    this.initMap();
  }

  private loadAvailability(availability: ResourceAvailability) {
    let viewExtent = createEmpty();

    let lastLocation = availability.resource.location;

    this.pending = false;
    let routePromises = [];
    let ticketSequence = 0;
    this.ticketStore
      .findByResourceAvailability(availability.id)
      .then((tickets) => {
        tickets.resources.forEach((ticket: Ticket_DetailProjection) => {
          this.loading = false;
          ticketSequence++;
          let currentSequence = ticketSequence;
          let resourceRouteDetail = new ResourceScheduleDetail();
          resourceRouteDetail.ticket = ticket;
          this.resourceScheduleDetails.push(resourceRouteDetail);
          // Add marker
          // new Feature(new Circle(fromLonLat([ticket.visit.job.location.longitude, ticket.visit.job.location.latitude]), 40))
          let routePromise = this.routeService.getRoute(
            lastLocation,
            ticket.visit.job.location
          );
          routePromises.push(routePromise);
          routePromise.then((route: RouteMessage) => {
            resourceRouteDetail.route = route;
            console.log("result", route);

            let ticketIcon = new Feature({
              type: "job",
              geometry: new Point(
                fromLonLat([
                  ticket.visit.job.location.longitude,
                  ticket.visit.job.location.latitude
                ])
              ),
              ticket: ticket,
              ticketSequence: currentSequence
            });

            let segmentFeature = new Feature({
              type: "route",
              geometry: new GeoJSON().readGeometry(route.geometry, {
                featureProjection: "EPSG:3857",
                dataProjection: "EPSG:4326"
              })
            });
            this.jobSource.addFeature(ticketIcon);
            this.routeSource.addFeature(segmentFeature);

            extend(viewExtent, segmentFeature.getGeometry().getExtent());

            this.mainView.fit(viewExtent, {
              duration: 1000
            });
          });
          lastLocation = ticket.visit.job.location;
        });
      });
  }

  private postProcess(tempStyle, feature): any {
    if (feature.get("type") === "job") {
      console.log("rendering feature");
      console.log(feature);
      tempStyle.setImage(
        new Icon({
          anchor: [0.5, 1],
          color: this._colors.status[feature.get("ticket").status]
            ? this._colors.status[feature.get("ticket").status].background
            : "#d1d1d1",
          src: "assets/markers/job1.svg"
        })
      );
      tempStyle.setText(
        new Text({
          // color: '#e70808',
          // fontFamily: 'Calibri,sans-serif',
          // fontSize: 200,
          // label: 'test',
          // labelYOffset: -12
        })
      );
      return [
        tempStyle,
        new Style({
          text: new Text({
            text: feature.get("ticket").visit.job.externalJobReference,
            font: "Calibri,sans-serif",
            offsetY: -35,
            fill: new Fill({
              color: "#000000"
            })
          })
        }),
        new Style({
          text: new Text({
            text: "" + feature.get("ticketSequence"),
            font: "12px bold sans-serif",
            offsetY: -16,
            fill: new Fill({
              color: "#000000"
            })
          })
        })
      ];
    }
    return tempStyle;
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  private mainStyleFunction(feature) {
    let tempStyle = this.styles[feature.get("type")];
    return this.postProcess(tempStyle, feature);
  }

  private highlightStyleFunction(feature) {
    let tempStyle = this.highlightStyles[feature.get("type")];
    if (feature.get("type") === "job") {
    }
    return this.postProcess(tempStyle, feature);
  }

  private initData(): Promise<any> {
    if (!this.resource) {
      return;
    }
    return this.resourceAvailabilityStore
      .findByResourceAndTimeRange(
        this.resource.id,
        this.data.dateFrom,
        this.data.dateTo,
        true
      )
      .then((availabilities) => {
        availabilities?.resources?.forEach(this.loadAvailability.bind(this));
      });
  }

  private initMap() {
    if (this.map) {
      this.map.dispose();
    }
    this.highlightSource = new VectorSource({
      features: []
    });
    this.highlightLayer = new VectorLayer({
      source: this.highlightSource,
      style: this.highlightStyleFunction.bind(this)
    });

    this.routeSource = new VectorSource({
      features: []
    });
    this.routeLayer = new VectorLayer({
      source: this.routeSource,
      style: this.mainStyleFunction.bind(this)
    });

    this.jobSource = new VectorSource({
      features: []
    });

    if (this.resource.location) {
      let homeIcon = new Feature({
        type: "home",
        geometry: new Point(
          fromLonLat([
            this.resource.location.longitude,
            this.resource.location.latitude
          ])
        )
      });
      this.jobSource.addFeature(homeIcon);
    }

    this.jobLayer = new VectorLayer({
      source: this.jobSource,
      style: this.mainStyleFunction.bind(this)
    });
    if (this.resource.location) {
      this.mainView = new View({
        center: fromLonLat([
          this.resource.location.longitude,
          this.resource.location.latitude
        ]),
        zoom: 12
      });
    }
    const config = this.clientConfigService.config;
    this.map = new Map({
      layers: [
        // new TileLayer({
        //   source: new OSM({})
        // }),
        new TileLayer({
          // id: 'System:Raster',
          source: new XYZ({
            attributions: [
              '<a href="https://www.openstreetmap.org/copyright">© OpenStreetMap</a> contributors'
            ],
            url: config.maps.tileUrl
            // serverType: 'mapserver'
          })
        }),
        this.routeLayer,
        this.jobLayer,
        this.highlightLayer
      ],
      controls: defaultControls({
        attribution: true
      }).extend([
        new Attribution({
          collapsible: false
        }),
        new FullScreen(),
        new ScaleLine()
      ]),
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
      target: "map",
      view: this.mainView
    });
    this.map.on("pointermove", this.handlePointerMove.bind(this));
    this.map.on("click", this.handleMapClick.bind(this));
  }

  private handleMapClick(e) {
    console.log("map click", e);
    this.highlightSource.clear();
    this.map.forEachFeatureAtPixel(
      e.pixel,
      this.selectFeaturesAtPixel.bind(this)
    );
  }

  private selectFeaturesAtPixel(f) {
    console.log(f);
    this.highlightSource.addFeature(f);
    if (f.get("type") === "job") {
      this.dialog.open(TicketActionDialogComponent, {
        hasBackdrop: false,
        autoFocus: false,
        width: "500px",
        panelClass: "toolbar-popup-dialog",
        data: {
          ticket: f.get("ticket")
        }
      });
    }
  }

  private handlePointerMove(e) {
    if (this.selected) {
      this.selected.setStyle(undefined);
      this.selected = null;
    }
    this.map.forEachFeatureAtPixel(
      e.pixel,
      this.hoverFeaturesAtPixel.bind(this)
    );

    //
    // if (selected) {
    //   status.innerHTML = '&nbsp;Hovering: ' + selected.get('name');
    // } else {
    //   status.innerHTML = '&nbsp;';
    // }
  }

  private hoverFeaturesAtPixel(f) {
    console.log(f);

    if (!!f) {
      this.selected = f;
      switch (f.get("type")) {
        case "route":
          const highlightStyle = new Style({
            fill: new Fill({
              color: "rgba(255,255,255,0)"
            }),
            stroke: new Stroke({
              color: "rgb(0,0,0,1)",
              width: 8
            })
          });
          f.setStyle([
            highlightStyle,
            new Style({
              stroke: new Stroke({
                color: "rgba(0,42,255,1)",
                width: 6
              })
            }),
            new Style({
              stroke: new Stroke({
                color: "rgba(70,134,255,1)",
                width: 4
              })
            })
          ]);
          break;
        case "job":
          this.selectedTicket = f.get("ticket");

          break;
        default: {
          break;
        }
      }
    } else {
      this.selectedTicket = null;
      this.selected = null;
    }
    return true;
  }
}
